import {
    createBuyPhotoOrder,
    textWxPay
} from '@/views/api'
import {
    showToast
} from 'vant'
export const readyWxPay = (params,fn) => {
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
        } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
        }
    } else {
        onBridgeReady(params,fn);
    }
}

const onBridgeReady = (params,fn) => {
      createBuyPhotoOrder(params).then(res => {
          let { appId, nonceStr, prepayId, sign, timestamp, orderId } = res;
        //   textWxPay({orderId}).then(res => {
        //        fn(res)
        //   })
          const payConfig = {
              "appId":appId, //公众号ID，由商户传入     
              timeStamp:timestamp, //时间戳，自1970年以来的秒数     
              "nonceStr": nonceStr, //随机串     
              "package": prepayId,
              "signType": "RSA", //微信签名方式：     
              "paySign": sign //微信签名 
          }
          WeixinJSBridge.invoke('getBrandWCPayRequest', payConfig, res => {
              fn(res)
          })
      })
}